import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';


@Component({
})
export default class OCKurukuru extends Mixins(BASEComponentVue) {
    @Prop({
        type: Boolean,
        default: false,
    })
    public value!: boolean;
}
